import React from 'react';
import { footerData } from '../data/footerData';

const FooterList = ({ img,link }) => {
  return (
    <div className="icons">
      <a href={link}>
        <img src={img} />
      </a>
    </div>
  );
};
const Footer = () => {
  return (
    <footer>
      <section>
        {footerData.map((footer) => {
          return <FooterList key={footer.id} {...footer} />;
        })}
      </section>
      <h2>Copyright &copy; Brian Maina</h2>
    </footer>
  );
};

export default Footer;
